import { Form } from 'react-bootstrap';

/**
 * Native HTML5 date input (same as Application Details tab date fields).
 * Use this for consistency with other date fields in the app.
 * Value can be a Date instance or an ISO/YYYY-MM-DD string.
 */
const NativeDate = ({
  label,
  name,
  value,
  onChange,
  className,
  labelClassName,
  inputClassName,
  disabled,
  onBlur,
  isInvalid,
}) => {
  const dateValue =
    value instanceof Date
      ? value.toISOString().split('T')[0]
      : typeof value === 'string' && value
        ? value.slice(0, 10)
        : '';

  return (
    <div className={className}>
      {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
      <Form.Control
        type="date"
        name={name}
        value={dateValue}
        disabled={disabled}
        className={inputClassName}
        onBlur={onBlur}
        isInvalid={isInvalid}
        onChange={(e) => onChange({ name, value: e.target.value || null })}
      />
    </div>
  );
};

export default NativeDate;
